import { useMutation } from 'react-query';
import { BASE_API_URL } from '@env';
import { useUserStore } from '~providers/userStore/zustand';
import { Alert } from 'react-native';
import { useTranslation } from 'react-i18next';

interface ReportEventRequest {
  user_id: string;
  event_id: number;
  reason: string;
}

export const useReportEvent = () => {
  const { t } = useTranslation();

  const { mutate, isLoading } = useMutation(
    async (payload: ReportEventRequest) => {
      const token = useUserStore.getState().token;
      const response = await fetch(`${BASE_API_URL}events/block`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
          'accept': 'application/json',
        },
        body: JSON.stringify(payload),
      });
       console.log('Report event error:', payload);

      if (!response.ok) {
        throw new Error(`Failed to report event: ${response.status}`);
      }

      const data = await response.json();
      return data;
    },
    {
      onSuccess: () => {
        Alert.alert(
          t('events.report_success_title', 'Report Submitted'),
          t('events.report_success_message', 'Thank you for reporting this event. We will review it shortly.'),
          [{ text: t('generic.ok', 'OK') }]
        );
      },
      onError: (error: Error) => {
        Alert.alert(
          t('events.report_error_title', 'Report Failed'),
          t('events.report_error_message', 'Failed to submit report. Please try again.'),
          [{ text: t('generic.ok', 'OK') }]
        );
        console.error('Report event error:', error);
      },
    }
  );

  return {
    reportEvent: mutate,
    isLoading,
  };
};
